export default __webpack_public_path__ + "static/user-manual_es-906e305119d41fca0ad82aaa1a55126a.pdf";